import { createContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ViewIcon from "../../../assets/images/right-more.png";
import RouteConstants from "../../../constants/routeConstants.json";
import { getAllBatteryList, getAllInverterList } from "../../../api/Api";
import { useCookies } from "react-cookie";
import { handleApiError } from "../../../constants/Constants";
export const ProductListViewContext = createContext({});
export const ProductListViewContextProvider = ({ children }) => {
  const navigate = useNavigate();
  const [searchData, setSearchData] = useState("");
  const location = useLocation();
  const currentPage = location?.state?.page;

  const [pageCount, setPageCount] = useState(currentPage ? currentPage : 1);
  const [totalPage, setTotalPage] = useState(0);
  const [productList, setProductList] = useState([]);
  const currentTabValue = localStorage.getItem("tabValue");
  const [statusValue, setStatusValue] = useState(0);
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState("");
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [buttonText, setButtonText] = useState("");
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const [inverterList, setInverterList] = useState([]);
  const [batteryList, setBatteryList] = useState([]);
  const [tabValue, setTabValue] = useState(
    currentTabValue ? currentTabValue : "1"
  );
  const [selectedStatusId, setSelectedStatusId] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [status, setStatus] = useState("");
  const permissionAccess = JSON.parse(
    localStorage.getItem("permissions")
  )?.filter((item) => {
    return item.feature === "67b416502efc50c984271c7c";
  })[0];

  useEffect(() => {
    const timeoutID = setTimeout(() => {
      if (tabValue == 1) {
        inverterListAPI(pageCount, status, searchData);
      } else {
        batteryListAPI(pageCount, status, searchData);
      }
    }, 900);
    return () => clearTimeout(timeoutID);
  }, [pageCount, searchData, tabValue, status]);

  useEffect(() => {
    if (tabValue == 1) {
      setProductList(
        inverterList?.map((product) => ({
          id: product?._id,
          model: product?.modelName,
          power: `${product?.power} W`,
          type: product?.type,
          siteOrigin:
            product?.siteOrigin === "com" ? "vguard.com" : "vguard.in",
          status: (
            <span
              style={{
                color:
                  product?.status === "A"
                    ? "#13BC5B" // Green for Active
                    : product?.status === "I"
                    ? "#EB5757" // Red for Inactive
                    : product?.status === "D"
                    ? "#dc3545" // Red for Deleted
                    : "#6c757d", // Default color (gray)
              }}
            >
              {product?.status === "A"
                ? "Active"
                : product?.status === "I"
                ? "Inactive"
                : product?.status === "D"
                ? "Deleted"
                : "Invited"}
            </span>
          ),
          action: (
            <div onClick={() => viewProductDetails(product?._id)}>
              <span>
                <img className="viewClickAdmin" src={ViewIcon} alt="view" />
              </span>
            </div>
          ),
        }))
      );
    } else {
      setProductList(
        batteryList?.map((product) => ({
          id: product?._id,
          model: product?.modelName,
          capacity: `${product?.capacity} Ah`,
          productLink: (
            <div>
              {product?.url?.length > 40
                ? product.url.slice(0, 40) + "..."
                : product?.url}
            </div>
          ),
          siteOrigin:
            product?.siteOrigin === "com" ? "vguard.com" : "vguard.in",
          status: (
            <span
              style={{
                color:
                  product?.status === "A"
                    ? "#13BC5B" // Green for Active
                    : product?.status === "I"
                    ? "#EB5757" // Red for Inactive
                    : product?.status === "D"
                    ? "#dc3545" // Red for Deleted
                    : "#6c757d", // Default color (gray)
              }}
            >
              {product?.status === "A"
                ? "Active"
                : product?.status === "I"
                ? "Inactive"
                : product?.status === "D"
                ? "Deleted"
                : "Invited"}
            </span>
          ),
          action: (
            <div onClick={() => viewProductDetails(product?._id)}>
              <span>
                <img className="viewClickAdmin" src={ViewIcon} alt="view" />
              </span>
            </div>
          ),
        }))
      );
    }
  }, [tabValue, inverterList, batteryList]);

  const addProduct = () => {
    navigate(RouteConstants.ADD_PRODUCT, { state: { tabValue: tabValue } });
  };

  // get all inverter List
  const inverterListAPI = async (page, status, search) => {
    try {
      setSpinnerStatus(true);
      const response = await getAllInverterList(page, status, search);
      if (response?.status === 200) {
        setSpinnerStatus(false);
        setInverterList(response?.data?.data?.inverters);
        setTotalPage(response?.data?.data?.totalPages);
      }
    } catch (error) {
      handleApiError(
        error,
        setStatusValue,
        setErrorPopupMessage,
        setErrorPopup,
        setButtonText
      );
    }
    setSpinnerStatus(false);
  };

  // get all battery list
  const batteryListAPI = async (page, status, search) => {
    try {
      setSpinnerStatus(true);
      const response = await getAllBatteryList(page, status, search);
      if (response?.status === 200) {
        setSpinnerStatus(false);
        setBatteryList(response?.data?.data?.battery);
        setTotalPage(response?.data?.data?.totalPages);
      }
    } catch (error) {
      handleApiError(
        error,
        setStatusValue,
        setErrorPopupMessage,
        setErrorPopup,
        setButtonText
      );
    }
    setSpinnerStatus(false);
  };

  const viewProductDetails = (id) => {
    navigate(RouteConstants.PRODUCT_DETAILS, {
      state: { id: id, page: pageCount },
    });
  };

  const onChangeSearch = (e) => {
    const specialCharacters = /[!@#$%^&*(),.?":{}|<>+\-_\/=;]/;
    if (specialCharacters.test(e.target.value)) {
    }
    setSearchData(e.target.value);
    setPageCount(1);
  };

  const onPageChange = (e) => {
    setPageCount(e);
  };
  const handleTabChange = (_event, newValue) => {
    setTabValue(newValue);
    setPageCount(1);
    setSearchData("");
    setTotalPage(0);
    setStatus("");
    setSelectedStatusId(""); // Reset selection filter
  };

  const productToLogin = () => {
    navigate(RouteConstants.LOGIN);
    removeCookie("x-access-token");
  };

  // status filter
  const handleSelect = () => {
    setShowDropdown(false);
  };

  const handleToggle = (isOpen) => {
    setShowDropdown(isOpen);
  };
  
  const onClickFilterButton = (statusId) => {
    setPageCount(1);
    setStatus(statusId);
    setShowDropdown(false);
  };

  const providerValue = {
    addProduct,
    onChangeSearch,
    onChangeSearch,
    searchData,
    pageCount,
    totalPage,
    permissionAccess,
    onPageChange,
    productList,
    tabValue,
    handleTabChange,
    errorPopup,
    errorPopupMessage,
    setErrorPopup,
    productToLogin,
    buttonText,
    inverterListAPI,
    statusValue,
    selectedStatusId,
    setSelectedStatusId,
    showDropdown,
    handleSelect,
    handleToggle,
    setStatus,
    onClickFilterButton,
    spinnerStatus,
  };
  return (
    <ProductListViewContext.Provider value={providerValue}>
      {children}
    </ProductListViewContext.Provider>
  );
};
